module.exports = __webpack_public_path__ + "img/1539356202.bc3aa590.jpg";